(function ($) {
  $(document).ready(function () {
    // Getting localized data.
    var profileObj = localizedData.profileScript;

    // Show user profile modal.
    $('#akd_edit_user_profile').on('click', function () {
      $('#akd_user_profile_modal').closest('.npx-popup-wrapper').show();
    });

    // Validate email address.
    $.validator.addMethod(
      'validEmail',
      function (value, element) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      },
      'Please enter a valid email address.'
    );

    // Validation method to ensure the value contains no spaces or is empty.
    $.validator.addMethod('noSpace', function (value) {
      return value == '' || value.trim().length != 0;
    });

    // Has a Digit
    $.validator.addMethod('pwnumber', function (value) {
      return /\d/.test(value); // has a digit
    });

    // Has a Special Character
    $.validator.addMethod('pwspecialchar', function (value) {
      return /([~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/? ])+/g.test(value); // Special Character
    });

    // Ensures only numbers, dashes, parentheses, and plus signs are allowed.
    $('#akd_user_contact').keypress(function (event) {
      return /^[0-9-()+]+$/.test(event.key);
    });

    // Validate phone number.
    $.validator.addMethod(
      'phoneNumberFormat',
      function (value, element) {
        return /^[0-9-()+]+$/.test(value);
      },
      'Please enter a valid phone number.'
    );

    // Show update password fields.
    $('#user_update_pass').on('click', function () {
      $(this).hide();
      $('#user_pass_info').hide();
      $('#akd_login_detail_form').show();
    });

    // Validate profile info form.
    $('#akd_user_profile_form').validate({
      rules: {
        fname: {
          required: true,
          noSpace: true,
        },
        lname: {
          required: true,
          noSpace: true,
        },
        phone: {
          required: false,
          phoneNumberFormat: true,
        },
        nickname: {
          required: {
            depends: function () {
              return $(".use-nickname").is(":checked");
            },
          },
        },
      },
      messages: {
        fname: {
          required: 'This field is required.',
          noSpace: 'Please enter a valid name',
        },
        lname: {
          required: 'This field is required.',
          noSpace: 'Please enter a valid name',
        },
        nickname: {
          required: "Nickname is required when the checkbox is checked.",
        },
      },
      submitHandler: function (form) {
        var form = new FormData($('#akd_user_profile_form')[0]);
        form.append('action', 'user_profile_update');
        form.append('nonce', profileObj.update_info_nonce);
        var useNickname = $(".use-nickname").is(":checked") ? 1 : 0;
        form.append("use_nickname", useNickname);
        $.ajax({
          url: profileObj.ajax_url,
          type: 'post',
          processData: false,
          contentType: false,
          data: form,
          beforeSend: function () {
            $('#akd_user_profile_form input[type=submit]').attr(
              'disabled',
              'disabled'
            );
            $('.profile-loader').show();
          },
          success: function (response) {
            $('#akd_user_profile_form input[type=submit]').removeAttr(
              'disabled'
            );
            $('.profile-loader').hide();
            if (response.success == true) {
              $('.profile-message').addClass('success');
              $('.profile-message').html(response.data.message);
            } else {
              $('.profile-message').addClass('error');
              $('.profile-message').html(response.data.message);
            }
          },
          error: function () {
            $('#akd_user_profile_form input[type=submit]').removeAttr(
              'disabled'
            );
            $('.profile-loader').hide();
            $('.profile-message').html('An error occurred. Please try again.');
          },
        });
      },
    });

    // Validate login details form.
    $('#akd_login_detail_form').validate({
      rules: {
        oldpass: {
          required: true,
        },
        newpass: {
          required: true,
          pwnumber: true,
          pwspecialchar: true,
          minlength: 10,
        },
      },
      messages: {
        oldpass: {
          required: 'Please provide your old password.',
        },
        newpass: {
          required: 'Please provide a new password.',
          pwnumber: 'Please include at least one digit.',
          pwspecialchar: 'Please include at least one special character.',
          minlength: 'Your password must be at least 10 characters long.',
        },
      },
      submitHandler: function (form) {
        var form = new FormData($('#akd_login_detail_form')[0]);
        form.append('action', 'user_update_password');
        form.append('nonce', profileObj.update_pass_nonce);
        $.ajax({
          url: profileObj.ajax_url,
          type: 'post',
          processData: false,
          contentType: false,
          data: form,
          beforeSend: function () {
            $('#akd_login_detail_form input[type=submit]').attr(
              'disabled',
              'disabled'
            );
            $('#akd_login_detail_form input').attr('readonly', true);
            $('.updateinfo-loader').show();
          },
          success: function (response) {
            $('#akd_login_detail_form input').attr('readonly', false);
            $('#akd_login_detail_form input[type=submit]').removeAttr(
              'disabled'
            );
            $('.updateinfo-loader').hide();
            if (response.success == true) {
              $('.updateinfo-message').addClass('success');
              $('.updateinfo-message').html(response.data.message);
            } else {
              $('.updateinfo-message').addClass('error');
              $('.updateinfo-message').html(response.data.message);
            }
          },
          error: function () {
            $('#akd_login_detail_form input').attr('readonly', false);
            $('#akd_login_detail_form input[type=submit]').removeAttr(
              'disabled'
            );
            $('.updateinfo-loader').hide();
            $('.updateinfo-message').html(
              'An error occurred. Please try again.'
            );
          },
        });
      },
    });

    $('.user-gallery-comment-reviews-wrapper .tab-section ul li').on(
      'click',
      function () {
        var listType = $(this).attr('data-list-type');
        $(this).addClass('active').siblings().removeClass('active');
        if (listType == 'gallery') {
          $('.user-gallery-list-wrapper').show();
          $('.user-comment-list-wrapper').hide();
          $(".user-gallery-comment-reviews-wrapper")
          .find(".tab-section") 
          .find(".right")
          .show();
        }
        if (listType == 'comment') {
          $('.user-gallery-list-wrapper').hide();
          $('.user-comment-list-wrapper').show();
          $(".user-gallery-comment-reviews-wrapper")
            .find(".tab-section")
            .find(".right")
            .hide();
        }
      }
    );

    //For the edit drop down show hide
    // $(".edit-icon").on("click", function (e) {
    //   e.stopPropagation();

    //   // Close all other .edit-icon-list elements
    //   $(".edit-icon-list")
    //     .not($(this).siblings(".edit-icon-list"))
    //     .css("display", "none");
    //   var editDropDown = $(this).siblings(".edit-icon-list");
    //   // Check the current display property and toggle it
    //   if (editDropDown.css("display") === "none") {
    //     editDropDown.css("display", "flex");
    //   } else {
    //     editDropDown.css("display", "none");
    //   }
    // });
  });
})(jQuery);
